<template>
  <td>
    <span v-if="isPrivate" class="tag is-danger">
      {{ location }}
    </span>

    <span v-if="!isPrivate">
      {{ location }}
    </span>
  </td>
</template>

<script>

export default {
  name: "LocationCell",
  props: {
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    isPrivate: function () {
      return this.location == "Private mode"
    }
  }
};

</script>

<style scoped></style>